// extracted by mini-css-extract-plugin
module.exports = {"familiesBanner":"FamiliesBanner_familiesBanner__BM3e9","minFamiliesBanner":"FamiliesBanner_minFamiliesBanner__SpFeA","maxFamiliesBanner":"FamiliesBanner_maxFamiliesBanner__aWg4v"};